import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(Object.entries,t)}export{t as entries};
//# sourceMappingURL=entries-IutXYNeS.js.map